import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Cross = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M7.99996 6.93954L4.99474 3.93433L3.93408 4.99499L6.9393 8.0002L3.9341 11.0054L4.99476 12.0661L7.99996 9.06086L11.0051 12.0661L12.0658 11.0054L9.06062 8.0002L12.0658 4.99499L11.0052 3.93433L7.99996 6.93954Z"
      fill="currentColor"
    />
  </Icon>
));

export default Cross;
